import { render, staticRenderFns } from "./UpgradePlanCardOneDark.vue?vue&type=template&id=5a2a997a"
import script from "./UpgradePlanCardOneDark.vue?vue&type=script&lang=js"
export * from "./UpgradePlanCardOneDark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports